import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CalendarConfig, TimeFilterConfig } from '@frontend/sports/common/client-config-data-access';
import { TimeFiltersPayload } from '@frontend/sports/types/components/widget/types';

import { WidgetComponent } from '../widget/core/widget-registry.service';
import { CalendarItemListComponent } from './calendar-item-list.component';
import { CalendarPage, CalendarService } from './calendar.service';
import { IntervalLink } from './count-interval.service';
import { TimeFrameLocation } from './time-filters-tracking.service';

@Component({
    selector: 'ms-time-filters-widget',
    templateUrl: './time-filters-widget.component.html',
    imports: [CalendarItemListComponent],
})
export class TimeFiltersWidgetComponent extends WidgetComponent<TimeFiltersPayload> {
    calendarIntervals: IntervalLink[] = [];
    readonly timeFrameLocation = TimeFrameLocation.FeaturedPage;

    constructor(
        private route: ActivatedRoute,
        private calendarService: CalendarService,
        private timeFilterConfig: TimeFilterConfig,
        private calendarConfig: CalendarConfig,
    ) {
        super();
    }

    protected override onData(_: TimeFiltersPayload): void {
        const { sport, sportName } = this.route.snapshot.params;

        this.calendarIntervals =
            this.timeFilterConfig.isTimeFilterEnabled && this.calendarConfig.showCalendarTab
                ? this.calendarService.getCalendarLinks(CalendarPage.Featured, { id: sport, name: sportName })
                : [];

        this.setWidgetLoaded();
    }
}
